import { Component, Input } from '@angular/core';
import { SelectService } from '../services/select.service';
var TreeSelectItemComponent = /** @class */ (function () {
    /**
     * @param {?} svc
     */
    function TreeSelectItemComponent(svc) {
        this.svc = svc;
    }
    Object.defineProperty(TreeSelectItemComponent.prototype, "isOpen", {
        /**
         * @return {?}
         */
        get: function () {
            return this.item.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} $event
     * @return {?}
     */
    TreeSelectItemComponent.prototype.toggleOpen = function ($event) {
        $event.stopPropagation();
        if (this.haveChildren) {
            this.item.isOpen = !this.item.isOpen;
        }
        else {
            this.select($event);
        }
    };
    Object.defineProperty(TreeSelectItemComponent.prototype, "allowParentSelection", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.allowParentSelection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectItemComponent.prototype, "restructureWhenChildSameName", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.restructureWhenChildSameName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectItemComponent.prototype, "needCheckBox", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.isHierarchy() && this.svc.Configuration.allowMultiple;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeSelectItemComponent.prototype, "haveChildren", {
        /**
         * @return {?}
         */
        get: function () {
            if (this.restructureWhenChildSameName && this.item && this.item.children
                && this.item.children.length === 1 && this.item.text === this.item.children[0].text) {
                this.item = this.item.children[0];
            }
            return this.item && this.item.children && this.item.children.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} $event
     * @return {?}
     */
    TreeSelectItemComponent.prototype.select = function ($event) {
        $event.stopPropagation();
        if (this.svc.Configuration.allowMultiple ||
            !this.haveChildren ||
            this.svc.Configuration.allowParentSelection) {
            this.svc.toggleItemSelection(this.item);
        }
        this.onTouchedCallBack();
    };
    Object.defineProperty(TreeSelectItemComponent.prototype, "filter", {
        /**
         * @return {?}
         */
        get: function () {
            return this.svc.Configuration.filter;
        },
        enumerable: true,
        configurable: true
    });
    TreeSelectItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'tree-select-item',
                    templateUrl: './tree-select-item.component.html',
                    styleUrls: ['./tree-select-item.component.scss']
                },] },
    ];
    /**
     * @nocollapse
     */
    TreeSelectItemComponent.ctorParameters = function () { return [
        { type: SelectService, },
    ]; };
    TreeSelectItemComponent.propDecorators = {
        'onTouchedCallBack': [{ type: Input },],
        'item': [{ type: Input },],
    };
    return TreeSelectItemComponent;
}());
export { TreeSelectItemComponent };
function TreeSelectItemComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    TreeSelectItemComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    TreeSelectItemComponent.ctorParameters;
    /** @type {?} */
    TreeSelectItemComponent.propDecorators;
    /** @type {?} */
    TreeSelectItemComponent.prototype.onTouchedCallBack;
    /** @type {?} */
    TreeSelectItemComponent.prototype.item;
    /** @type {?} */
    TreeSelectItemComponent.prototype.svc;
}
//# sourceMappingURL=tree-select-item.component.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/custom-tree-select/src/components/tree-select-item.component.js
// module id = 168
// module chunks = 0